import React from 'react';
import { Text } from '@admitkard/ccl/Text';
import { theme } from '@admitkard/ccl/style';
import { AkHead } from 'components/AkHead';
import { MentorsBenefits } from 'components/MentorsBenefits';
import { StepsToConnect } from './StepsToConnect';
import { AkMentorsListing } from './AkMentorsListing';
import { MentorsDetailsListInterface } from './AkMentorsListing';
import { env } from '@admitkard/uiutils/env';

export class ConnectWithMentors extends React.Component<MentorsDetailsListInterface> {
  render() {
    const benefitsList = [{
      icon: env.getAssetUrl('images/recommendation.svg'),
      title: 'Get Recommendation',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }, {
      icon: env.getAssetUrl('images/verify-documents.svg'),
      title: 'Verify Documents',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }, {
      icon: env.getAssetUrl('images/live-moments.svg'),
      title: 'Live the Experience',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }, {
      icon: env.getAssetUrl('images/doubts.svg'),
      title: 'Clean your Doubts',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }, {
      icon: env.getAssetUrl('images/how-to-apply.svg'),
      title: 'Help you Apply',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }, {
      icon: env.getAssetUrl('images/graduation-hat.svg'),
      title: 'Find Scholarships',
      description: 'Mentors will suggest the best courses & universities based on your profile',
    }];

    return (
      <>
        <AkHead />
        <div className="connect-with-mentor-page">
          <div className="connect-with-mentor__page-header-image">
          </div>
          <div className="connect-with-mentor-container container">
            <div className="connect-with-mentor__connection-benefits-wrapper">
              <Text
                variant='h3'
                className="connect-with-mentor__connection-benefits-title"
                display='block'
                weight='normal'>
                You Get Guidance, Help and More
              </Text>
              <MentorsBenefits benefitsList={benefitsList} />
            </div>

            <div className="connect-with-mentor__how-to-steps-wrapper">
              <Text
                variant='h3'
                className="connect-with-mentor__how-to-steps-title"
                display='block'
                weight='normal'>
                Your Guidance to Connect with Mentors
              </Text>
              <StepsToConnect />
            </div>

            <div className="connect-with-mentor__ak-mentors-list-container">
              <AkMentorsListing mentorsListing={this.props.mentorsListing} />
            </div>
          </div>
        </div>
        <style>{`
          .connect-with-mentor-container {
            max-width: 85rem;
            width: 100%;
            margin: ${theme.spacingOld(7)} auto;
          }
          .connect-with-mentor__page-header-image {
            box-shadow: 0px 100px 50px -25px #fff inset;
            background-image: url(${env.getAssetUrl('images/connect-with-mentor-header-image.png')});
            height: 0px;
            padding-top: 20%;
            background-size: cover;
          }
          .connect-with-mentor__connection-benefits-title, .connect-with-mentor__how-to-steps-title {
            text-align: center;
          }
          @media screen and (min-width: 425px) and (max-width: 768px) {
            .connect-with-mentor-container {
              max-width: 720px;
            }
          }
          @media screen and (max-width: 425px) {
            .connect-with-mentor-container {
              max-width: 90%;
              margin-left: auto;
              margin-right: auto;
            }
          }
        `}</style>
      </>
    );
  }
}
